import { type PaymentService } from "utils/api/payment";

export class ProviderScriptLoadError extends Error {
  provider: string;

  constructor({
    message,
    provider,
  }: {
    message?: string;
    provider: PaymentService;
  }) {
    super(message ?? `${provider} is not available`);
    this.name = "ProviderScriptLoadError";
    this.provider = provider;
  }
}
